import { SvgIconProps } from '@mui/material';
import { CommonLightingIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/common/CommonLightingIcon";
import { LoxoneControlsIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/loxone/LoxoneControlsIcon";
import { CommonShadingIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/common/CommonShadingIcon";
import { LoxoneSecurityIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/loxone/LoxoneSecurityIcon";
import { CommonHVACIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/common/CommonHVACIcon";
import { LoxoneMusicIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/loxone/LoxoneMusicIcon";
import { CommonETCIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/common/CommonETCIcon";
import {
    ConventionalMotionSensorIcon
} from "src/icons/planner/subcategoryIcons/deviceIcons/conventional/ConventionalMotionSensorIcon";
import {
    ConventionalMultimediaIcon
} from "src/icons/planner/subcategoryIcons/deviceIcons/conventional/ConventionalMultimediaIcon";
import {
    ConventionalSocketOutletIcon
} from "src/icons/planner/subcategoryIcons/deviceIcons/conventional/ConventionalSocketOutletIcon";
import {
    ConventionalTemperatureIcon
} from "src/icons/planner/subcategoryIcons/deviceIcons/conventional/ConventionalTemperatureIcon";
import { ITAccessPointIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/it/ITAccessPointIcon";
import { ITCameraIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/it/ITCameraIcon";
import {
    CabinetsElectricalCabinetIcon
} from "src/icons/planner/subcategoryIcons/deviceIcons/cabinets/CabinetsElectricalCabinetIcon";
import {
    CabinetsRackCabinetIcon
} from "src/icons/planner/subcategoryIcons/deviceIcons/cabinets/CabinetsRackCabinetIcon";
import { MinaloxLampsIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/minalox/MinaloxLampsIcon";
import { MinaloxLedPanelsIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/minalox/MinaloxLedPanelsIcon";
import { MinaloxLedStripsIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/minalox/MinaloxLedStripsIcon";
import { NikoIntercomIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/niko/NikoIntercomIcon";
import { NikoPowerIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/niko/NikoPowerIcon";
import { NikoWirelessIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/niko/NikoWirelessIcon";
import { IT_GenericDevicesIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/common/IT_GenericDevicesIcon";
import { Switch_ControllerIcon } from "src/icons/planner/subcategoryIcons/deviceIcons/common/Switch_ControllerIcon";
import { GardenIcon } from "src/icons/planner/subcategoryIcons/floorIcons/GardenIcon";
import { FloorIcon } from "src/icons/planner/subcategoryIcons/floorIcons/FloorIcon";
import { BedroomIcon } from "src/icons/planner/subcategoryIcons/floorIcons/BedroomIcon";
import { LivingRoomIcon } from "src/icons/planner/subcategoryIcons/floorIcons/LivingRoomIcon";
import { BathroomIcon } from "src/icons/planner/subcategoryIcons/floorIcons/BathroomIcon";
import { KitchenIcon } from "src/icons/planner/subcategoryIcons/floorIcons/KitchenIcon";
import { StudyIcon } from "src/icons/planner/subcategoryIcons/floorIcons/StudyIcon";
import { CorridorIcon } from "src/icons/planner/subcategoryIcons/floorIcons/CorridorIcon";
import { CentralIcon } from "src/icons/planner/subcategoryIcons/floorIcons/CentralIcon";
import { ToiletIcon } from "src/icons/planner/subcategoryIcons/floorIcons/ToiletIcon";
import { GarageIcon } from "src/icons/planner/subcategoryIcons/floorIcons/GarageIcon";
import { OtherIcon } from "src/icons/planner/subcategoryIcons/floorIcons/OtherIcon";
import { BalconyIcon } from "src/icons/planner/subcategoryIcons/floorIcons/BalconyIcon";
import { OutdoorIcon } from "src/icons/planner/subcategoryIcons/floorIcons/OutdoorIcon";

interface Props extends SvgIconProps {
    id: string;
}

const iconMap: Record<string, React.ElementType> = {
    LOXONE_LIGHTING: CommonLightingIcon,
    LOXONE_PUSHBUTTON: LoxoneControlsIcon,
    LOXONE_SECURITY: LoxoneSecurityIcon,
    LOXONE_SHADING: CommonShadingIcon,
    LOXONE_HVAC: CommonHVACIcon,
    LOXONE_MUSIC: LoxoneMusicIcon,
    LOXONE_ETC: CommonETCIcon,

    CONVENTIONAL_SOCKET_OUTLET: ConventionalSocketOutletIcon,
    CONVENTIONAL_MULTIMEDIA: ConventionalMultimediaIcon,
    CONVENTIONAL_IT: IT_GenericDevicesIcon,
    CONVENTIONAL_SWITCH: Switch_ControllerIcon,
    CONVENTIONAL_TEMPERATURE: ConventionalTemperatureIcon,
    CONVENTIONAL_MOTION_SENSOR: ConventionalMotionSensorIcon,
    CONVENTIONAL_LIGHTING: CommonLightingIcon,
    CONVENTIONAL_SHADING: CommonShadingIcon,
    CONVENTIONAL_ETC: CommonETCIcon,

    IT_ACCESS_POINT: ITAccessPointIcon,
    IT_CAMERA: ITCameraIcon,
    IT_GENERIC_DEVICES: IT_GenericDevicesIcon,

    CABINETS_ELECTRICAL_CABINET: CabinetsElectricalCabinetIcon,
    CABINETS_RACK_CABINET: CabinetsRackCabinetIcon,

    MINALOX_LAMPS: MinaloxLampsIcon,
    MINALOX_LED_PANELS: MinaloxLedPanelsIcon,
    MINALOX_LED_STRIPES: MinaloxLedStripsIcon,

    NICO_LIGHTING: CommonLightingIcon,
    NICO_SHADING: CommonShadingIcon,
    NICO_HVAC: CommonHVACIcon,
    NICO_CONTROLLER: Switch_ControllerIcon,
    NICO_POWER: NikoPowerIcon,
    NICO_WIRELESS: NikoWirelessIcon,
    NICO_INTERCOM: NikoIntercomIcon,
    NICO_ETC: CommonETCIcon,

    FLOOR_ICON: FloorIcon,
    "Bedroom": BedroomIcon,
    "Living room": LivingRoomIcon,
    "Bathroom": BathroomIcon,
    "Kitchen": KitchenIcon,
    "Working room": StudyIcon,
    "Corridor": CorridorIcon,
    "Central": CentralIcon,
    "Toilet": ToiletIcon,
    "Garage": GarageIcon,
    "ETC": OtherIcon,
    "Terrace/Balcony": BalconyIcon,
    "Garden": GardenIcon,
    "Unassigned": OutdoorIcon
};

export const SubcategoryIcon = ({ id, ...iconProps }: Props) => {
    const IconComponent = iconMap[id];
    if (!IconComponent) return null;

    return <IconComponent {...iconProps} />;
};
